var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgBlob = function SvgBlob(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 185,
    height: 257,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92.5 257c51.086 0 92.5-57.531 92.5-128.5S143.586 0 92.5 0 0 57.531 0 128.5 41.414 257 92.5 257z",
    fill: "#E0EAF9"
  })));
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTg1IiBoZWlnaHQ9IjI1NyIgdmlld0JveD0iMCAwIDE4NSAyNTciIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik05Mi41IDI1N0MxNDMuNTg2IDI1NyAxODUgMTk5LjQ2OSAxODUgMTI4LjVDMTg1IDU3LjUzMTQgMTQzLjU4NiAwIDkyLjUgMEM0MS40MTM3IDAgMCA1Ny41MzE0IDAgMTI4LjVDMCAxOTkuNDY5IDQxLjQxMzcgMjU3IDkyLjUgMjU3WiIgZmlsbD0iI0UwRUFGOSIvPgo8L3N2Zz4K";
export { SvgBlob as ReactComponent };